import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

@Model()
class OutreachContactLocation extends ApplicationRecord {
  static jsonapiType = "outreach_contact_locations";

  @HasMany() children: OutreachContactLocation[];

  @Attr() locationType: string;

  @Attr() name: string;

  @BelongsTo() parent: OutreachContactLocation;

  @Attr() parentHierarchy: JSON;

  @Attr() parentId: number;

  @Attr() parentName: string[];

  @Attr() selfAndParentIds: number[];

  @Attr() selfAndParentNames: string[];

  @Attr() visible: boolean;
}

export default OutreachContactLocation;
